export const blockIconsContentSave = (
	<span className='material-symbols-outlined'>save</span>
);
